// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".term-tag-header__wrapper .term-tag-header__description-wrapper[data-v-2e7df64d]{display:block;max-width:1000px;margin-top:20px}.term-tag-header__wrapper .term-tag-header__description[data-v-2e7df64d]{white-space:pre-wrap}.term-tag-header__wrapper .term-tag-header__description[data-v-2e7df64d] a{color:#a363ff}.term-tag-header__wrapper .term-tag-header__description[data-v-2e7df64d] a:hover{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
